import { useState } from "react";
import { useLocale, useService } from "../../../../hooks";

export const useComplaint = () => {
  const { t } = useLocale();
  const { save } = useService("Data", "complaint");
  const { setTitle } = useService("Meta");
  const { generateUID, showAlert } = useService("Misc");
  const { isValidMobile } = useService("Validation");
  const [name, setname] = useState<string>("");
  const [email, setemail] = useState<string>("");
  const [message, setmessage] = useState<string>("");
  const [orderId, setorderId] = useState<string>("");
  const [number, setnumber] = useState<string>("");
  const [productName, setproductName] = useState<string>("");
  const [complaintType, setcomplaintType] = useState("product");

  setTitle("Complaint");

  const sendComplaintRequest = async (e) => {
    e.preventDefault();
    let error = false,
      errorMsg = "",
      userObject = {
        name,
        email,
        message,
        orderId,
        number,
        productName,
        complaintType,
        date: new Date(),
        uid: generateUID(),
        status: "raised",
      };
    if (name === "") {
      errorMsg = t("errorMsg.required.name");
      error = true;
    } else if (email === "") {
      errorMsg = t("errorMsg.required.email");
      error = true;
    } else if (number === "") {
      errorMsg = t("errorMsg.required.mobile");
      error = true;
    } else if (!isValidMobile(number)) {
      errorMsg = t("errorMsg.validate.mobile");
      error = true;
    } else if (message.length < 20) {
      errorMsg = t("errorMsg.validate.message");
      error = true;
    }
    if (!error) {
      const result = await save(userObject);
      if (result.status) {
        showAlert({
          type: "info",
          msg: "Your contact request has been submitted. We'll contact you back in 24 hours.",
        });
        setname("");
        setemail("");
        setmessage("");
        setorderId("");
        setproductName("");
        setnumber("");
      } else
        showAlert({ type: "error", msg: "Unable to send contact request." });
    } else showAlert({ type: "error", msg: errorMsg });
  };
  return {
    setmessage,
    message,
    setproductName,
    productName,
    setorderId,
    orderId,
    setnumber,
    number,
    email,
    setemail,
    name,
    setname,
    sendComplaintRequest,
    complaintType,
    setcomplaintType,
  };
};
